import React from 'react';
import PropTypes from 'prop-types';

const PlainText = ({ value, className, style }) => (
  <span className={className} style={style}>
    {value}
  </span>
);

PlainText.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.string,
};

export default PlainText;
